export default __webpack_public_path__ + "static/media/igo.0903b5bf.svg";